import { configValue } from "./config";

declare global {
  interface Window {
    _paq?: unknown[][];
  }
}

export type ProductEvent =
  | "pricing_cta"
  | "registration_started"
  | "registration_completed"
  | "checkout_started"
  | "subscription_activated"
  | "upgrade"
  | "downgrade"
  | "pwa_install_intent";

let initialized = false;

export function analyticsDisabledByPrivacySignal() {
  const navigatorWithGpc = navigator as Navigator & {
    globalPrivacyControl?: boolean;
  };
  return navigator.doNotTrack === "1" || navigatorWithGpc.globalPrivacyControl === true;
}

export function initializeAnalytics() {
  if (analyticsDisabledByPrivacySignal()) return false;
  if (initialized) return true;
  const baseUrl = configValue("MATOMO_URL").replace(/\/$/, "");
  const siteId = configValue("MATOMO_SITE_ID");
  if (!baseUrl || !siteId) return false;

  window._paq = window._paq || [];
  window._paq.push(["disableCookies"]);
  window._paq.push(["setDoNotTrack", true]);
  window._paq.push(["disableBrowserFeatureDetection"]);
  window._paq.push(["setTrackerUrl", `${baseUrl}/matomo.php`]);
  window._paq.push(["setSiteId", siteId]);

  const script = document.createElement("script");
  script.async = true;
  script.src = `${baseUrl}/matomo.js`;
  script.dataset.verlofkaartAnalytics = "true";
  document.head.appendChild(script);
  initialized = true;
  return true;
}

export function trackPageView(path: string) {
  if (!initializeAnalytics()) return;
  window._paq?.push(["setCustomUrl", normalizeAnalyticsPath(path)]);
  window._paq?.push(["setReferrerUrl", ""]);
  window._paq?.push(["setDocumentTitle", "DeVerlofkaart"]);
  window._paq?.push(["trackPageView"]);
}

export function normalizeAnalyticsPath(path: string) {
  const pathname = new URL(path, window.location.origin).pathname;
  if (pathname.startsWith("/team-invite/")) return "/team-invite/:token";
  return pathname;
}

export function trackProductEvent(action: ProductEvent) {
  if (!initializeAnalytics()) return;
  window._paq?.push(["trackEvent", "Product", action]);
}
